class V1SetConfigurator
{
  _gid; 
  _payload;
  _total;
  _tiers;
  _stepsize;
  _setTitle;
  _setImage;
  _delete = [];
  _select = [];
  _allowSelect;
  _redirectToCart;
  _hideBadge;
  _itemSelector = 'product-card';
  _strSalePrice = '';
  _strRegularPrice = '';
  _strSelect = '';
  _strDeselect = '';
  
  constructor(stepsize = 1, setTitle = 'Set', setImage = '', preDeleteIds = new Array(), preSelectIds = new Array(), allowSelect = true, discounts = new Array(), redirectToCart = true, translations = {}) 
  {
    this.reset();
    this._tiers = (Array.isArray(discounts) && discounts.length > 0) ? discounts : [{tier: 0, discount: 0, type: 'percent'}];
    this._stepsize = parseInt(stepsize);
    this._setTitle = setTitle;
    this._setImage = setImage.toString();
    this._delete = Array.isArray(preDeleteIds) ? preDeleteIds : [];
    this._select = Array.isArray(preSelectIds) ? preSelectIds : [];
    this._allowSelect = Boolean(allowSelect);
    this._redirectToCart = Boolean(redirectToCart);

    this._strSalePrice = (window.themeVariables.strings.salePrice !== undefined) ? window.themeVariables.strings.salePrice : 'Offer';
    this._strRegularPrice = (window.themeVariables.strings.regularPrice !== undefined) ? window.themeVariables.strings.regularPrice : 'Regular Price';
    this._strSelect = (translations.select !== undefined) ? translations.select : 'Select';
    this._strDeselect = (translations.deselect !== undefined) ? translations.deselect : 'Deselect';
    
    this.getUrlParams();
    this.preDeleteItems();
    this.preSelectItems();    
    this.sortTiers();
    this.addEventListenersAsync();
  }
  
  reset()
  {
    this._gid = Date.now();
    this._payload = {items: []};
    this._total = 0;
    document.querySelectorAll('.v1-set-configurator-badge').forEach((item) => {
      item.classList.remove("active");
    });
    this.toggleAddToCartAsync();
  }
  
  getUrlParams()
  {
    let params = new URLSearchParams(window.location.search);
    // delete
    if(params.has('v1d')) {
      this._delete = this._delete.concat(params.get('v1d').split(","));
    }
    // select
    if(params.has('v1s')) {
      this._select = this._select.concat(params.get('v1s').split(","));
    }
  }

  getAllProducts()
  {
    let products = [];
    document.querySelectorAll(this._itemSelector).forEach((item) => {
      products.push(item.dataset.id)
    });
    return products;
  }
  
  preDeleteItems()
  {
    document.querySelectorAll(this._itemSelector).forEach((item) => {
      if(this._delete.includes(item.dataset.id)) {
        item.remove();
      }
    });
  }
  
  preSelectItems()
  {    
    if(this._select.includes('all')) 
    {
     this._select = this.getAllProducts();
    }
    this._select.forEach(async (id) => {
      if(await this.productExists(id))
      {
        await this.processProductClickAsync(id);
      }
    });
  }

  sortTiers()
  {
    this._tiers = this._tiers.sort(function (a, b) {return parseInt(b.tier) - parseInt(a.tier)});
  }
  
  async addEventListenersAsync()
  {
    if(this._allowSelect) 
    {
      document.querySelectorAll('.product-card__figure').forEach((button) => {
        button.addEventListener("click", (event) => this.toggleProductClickAsync(event));
      });
    }
    
    document.querySelector('#v1-set-configurator-btn-submit').addEventListener("click", 
      (event) => this.sendButtonClickAsync(event)
    );

    window.addEventListener('toggle', (event) => {
      let button = document.querySelectorAll('buy-buttons button[type="submit"]').forEach((button) => {
        //let id = button.closest('.buy-buttons')?.dataset?.id || undefined;
        let id = button.closest('.quick-buy-modal__info-wrapper')?.dataset?.diy || undefined;
        if(id === undefined || !this._allowSelect) {
          button.innerHTML = this._strSelect;
          button.disabled = true;
        } else {
          this.toggleModalButtonAsync(id, button);
          button.addEventListener("click", async (event) => {
              event.preventDefault();
              await this.processProductClickAsync(id);
              this.toggleModalButtonAsync(id, button);
          }, false);
        }        
      });
    });

  }

  async toggleModalButtonAsync(id, button) 
  {
    button.innerHTML = (await this.getStorageQuantityAsync(id) == 0) ? this._strDeselect : this._strSelect;
  }
  
  async toggleProductClickAsync(event) 
  {
    event.preventDefault();
    let id = event?.target?.closest(this._itemSelector).dataset?.id || undefined;
    if(id !== undefined) this.processProductClickAsync(id);
  }

  async productExists(id)
  {
    return (document.querySelector('[data-id="'+id+'"]') != null);
  }
  
  async processProductClickAsync(id)
  {
    let qty = await this.getStorageQuantityAsync(id);

    await this.addStorageAsync(id, qty, 'item');
    this.toggleBadgeAsync(id);
    this.toggleAddToCartAsync();
  }
  
  async toggleBadgeAsync(id)
  {
    document.querySelector('#v1-set-configurator-badge-'+id).classList.toggle('active');      
  }
  
  async sendButtonClickAsync(event)
  {
    event.preventDefault();    
    if(this._payload.items.length > 0) 
    {
        await this.addToCartAsync();
        // (this._redirectToCart) ? location.href = '/cart' : location.reload();

        if(this._redirectToCart) {
          //location.href = '/cart';
        } else {
          this.reset();
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true}));
          document.querySelector('cart-drawer').show();
        }
    }
  }
  
  async addStorageAsync(id, qty = 0, type = 'item')
  {
    let data = {'id': id, 'quantity': qty, 'properties': {'_grenion_bundle': 52260701012304, '_v1-set-configurator-title': this._setTitle, '_v1-set-configurator-image': this._setImage, '_v1-set-configurator-type': type}};
    let index = this._payload.items.findIndex(item => item.id === data.id);

    if(index === -1 && data.quantity > 0) 
    {
        this._payload.items.push(data);
    } 
    else 
    {
        if(data.quantity <= 0) 
        {
            this._payload.items.splice(index, 1);
        } 
        else 
        {
            this._payload.items[index] = data;
        }
    }
    this.calculatePriceAsync();
  }
   
  async getStorageQuantityAsync(id) 
  {
    let index = this._payload.items.findIndex(item => item.id === id);
    let increase = (index === -1 || index === null || index === undefined || index === NaN) ? true : false;
    let qty = (index === -1 || index === null || index === undefined) ? 0 : this._payload.items[index].quantity;

    if(qty >= 0 && increase) 
    {
        return qty + this._stepsize;
    }
    if(qty >= this._stepsize && !increase) 
    {
        return qty - this._stepsize;
    }
    return 0;
  }

  async calculatePriceAsync()
  {
    this._total = 0;
    this._payload.items.forEach((item) => {
      let p = parseInt(document.querySelector('[data-id="'+ item.id +'"]').dataset.price);
      this._total += (p < 0 || isNaN(p)) ? 0 : (p * item.quantity);
    });
  }

  async getTotalPriceAsync(withDiscount = true, inCents = true)
  {
    let total = (this._total < 0 || isNaN(this._total)) ? 0 : this._total;

    if(withDiscount)
    {
      let tier = await this.getDiscountAsync();
      total = (tier.type == 'percent') ? (total - (total * (tier.discount / 100))) : (total - (tier.discount * 100));
    }
    return (inCents) ? total : (total / 100);
  }

  async getPriceHtml(showDiscount = true, inCents = true, formatted = true)
  {
    let regular = await this.getTotalPriceAsync(false, inCents);
    let discounted = (showDiscount) ? await this.getTotalPriceAsync(true, inCents) : 0;

    if(formatted) 
    {
      return (showDiscount) ? await this.formatPrice(regular, discounted) : await this.formatPrice(regular, discounted, false);
    }
    
    return (showDiscount) ? '<span class="price regular"><del>' + regular +'</del></span><span class="price discounted">' + discounted +'</span>' : '<span class="price regular">' + regular +'</span>';
  }

  async formatPrice(regular = 0, discounted = 0, showDiscount = true)
  {
    let format = (window.themeVariables.settings.currencyCodeEnabled) ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    regular = this.formatMoney(regular, format);
    discounted = this.formatMoney(discounted, format);
    let discountedHmtl = '<sale-price class="price-on-sale"><span class="sr-only">'+this._strSalePrice+'</span>'+discounted+'</sale-price>';
    let regularHtml = (showDiscount) ? '<compare-at-price class="text-subdued line-through"><span class="sr-only">'+this._strRegularPrice+'</span>'+regular+'</compare-at-price>' : '';
    console.log(this._strRegularPrice,regular,discounted);
    return '<price-list class="price-list">'+regularHtml+discountedHmtl+'</price-list>';
  }
  
  async getDiscountAsync()
  {
    let count = this._payload.items.length;
    let tier = this._tiers.find(o => count >= o.tier);

    return (tier !== undefined) ? tier : {tier: 0, discount: 0, type: 'percent'};
  }

  // -------------------------------------------
  
  formatWithDelimiters(number, precision, thousands, decimal) 
  {
    precision = this.defaultTo(precision, 2);
    thousands = this.defaultTo(thousands, ",");
    decimal = this.defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }

  defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }  
  
  formatMoney(cents, format = "") 
  {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) 
    {
      case "amount":
        value = this.formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = this.formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = this.formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = this.formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = this.formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = this.formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = this.formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = this.formatWithDelimiters(cents, 0, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  
  // -------------------------------------------
  
  async toggleAddToCartAsync()
  {
    let count = this._payload.items.length;
    document.querySelector('#v1-set-configurator-add-to-cart-price').innerHTML = await this.getPriceHtml();
    document.querySelector('#v1-set-configurator-add-to-cart-hint').classList.toggle('hidden', (count > 1));
    document.querySelector('#v1-set-configurator-add-to-cart-set-image').classList.toggle('hidden', (count < 2));
    document.querySelector('#v1-set-configurator-add-to-cart-set-title').classList.toggle('hidden', (count < 2));
    document.querySelector('#v1-set-configurator-add-to-cart-price').classList.toggle('hidden', (count < 2));
    document.querySelector('#v1-set-configurator-btn-submit').classList.toggle('hidden', (count < 2));
    document.querySelector('#v1-set-configurator-btn-submit').disabled = (count < 2);
  }
  
  async addToCartAsync() 
  {
    console.log(this._payload);
    let response = await fetch("/cart/add.js", {
        method: "post",
        headers: {"Accept": "application/json", "Content-Type": "application/json"},
        body: JSON.stringify(this._payload)
    });
    return response.json();
  }  
}

if (typeof v1 !== 'undefined') {
  const setConfigurator = new V1SetConfigurator(v1.stepsize, v1.setTitle, v1.setImage, v1.preDeleteIds, v1.preSelectIds, v1.allowSelect, v1.discounts, v1.redirectToCart, v1.translations);
} else {
  const setConfigurator = new V1SetConfigurator();
}